var _circle, _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadimageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 26,
    r: 22,
    fill: "#1D3354"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6088 20.9278C28.6088 22.5582 27.9611 24.1219 26.8082 25.2748C25.6553 26.4277 24.0917 27.0754 22.4613 27.0754C20.8308 27.0754 19.2672 26.4277 18.1143 25.2748C16.9614 24.1219 16.3137 22.5582 16.3137 20.9278C16.3137 19.2974 16.9614 17.7337 18.1143 16.5808C19.2672 15.428 20.8308 14.7803 22.4613 14.7803C24.0917 14.7803 25.6553 15.428 26.8082 16.5808C27.9611 17.7337 28.6088 19.2974 28.6088 20.9278ZM25.535 20.9278C25.535 21.743 25.2112 22.5249 24.6347 23.1013C24.0583 23.6777 23.2765 24.0016 22.4613 24.0016C21.646 24.0016 20.8642 23.6777 20.2878 23.1013C19.7113 22.5249 19.3875 21.743 19.3875 20.9278C19.3875 20.1126 19.7113 19.3308 20.2878 18.7543C20.8642 18.1779 21.646 17.854 22.4613 17.854C23.2765 17.854 24.0583 18.1779 24.6347 18.7543C25.2112 19.3308 25.535 20.1126 25.535 20.9278Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4614 8.63281C13.1248 8.63281 5.55566 16.202 5.55566 25.5386C5.55566 34.8751 13.1248 42.4443 22.4614 42.4443C31.798 42.4443 39.3671 34.8751 39.3671 25.5386C39.3671 16.202 31.798 8.63281 22.4614 8.63281ZM8.62943 25.5386C8.62943 28.7506 9.72523 31.7076 11.5618 34.056C12.8519 32.3625 14.5159 30.9901 16.424 30.0458C18.332 29.1015 20.4324 28.6109 22.5613 28.6123C24.6628 28.6099 26.7371 29.0874 28.626 30.0084C30.515 30.9294 32.1686 32.2696 33.4609 33.9269C34.7925 32.1804 35.6891 30.1419 36.0765 27.98C36.4639 25.8182 36.3309 23.5952 35.6886 21.495C35.0463 19.3948 33.9131 17.4777 32.3827 15.9023C30.8524 14.327 28.969 13.1387 26.8882 12.4358C24.8075 11.733 22.5893 11.5356 20.4171 11.8602C18.245 12.1848 16.1814 13.022 14.397 14.3025C12.6127 15.5829 11.1589 17.2699 10.1559 19.2238C9.15297 21.1777 8.62971 23.3423 8.62943 25.5386ZM22.4614 39.3705C19.2861 39.3757 16.2065 38.2833 13.7442 36.2783C14.7352 34.8592 16.0544 33.7005 17.5896 32.9009C19.1248 32.1014 20.8304 31.6846 22.5613 31.6861C24.2706 31.6846 25.9556 32.091 27.4762 32.8715C28.9969 33.652 30.3094 34.7841 31.3046 36.1738C28.8233 38.244 25.6929 39.3756 22.4614 39.3705Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_802_771)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 13,
    r: 9,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.174 11.646H37.632C38.052 11.646 38.358 11.7 38.55 11.808C38.742 11.904 38.868 12.054 38.928 12.258C39 12.462 39.036 12.738 39.036 13.086C39.036 13.422 39.006 13.692 38.946 13.896C38.886 14.1 38.784 14.244 38.64 14.328C38.424 14.436 38.118 14.49 37.722 14.49H36.174V15.948C36.174 16.368 36.12 16.674 36.012 16.866C35.916 17.058 35.766 17.19 35.562 17.262C35.358 17.322 35.082 17.352 34.734 17.352C34.398 17.352 34.128 17.322 33.924 17.262C33.72 17.19 33.576 17.076 33.492 16.92C33.384 16.692 33.33 16.362 33.33 15.93V14.49H31.764C31.368 14.49 31.08 14.442 30.9 14.346C30.72 14.25 30.6 14.1 30.54 13.896C30.48 13.68 30.45 13.404 30.45 13.068C30.45 12.732 30.48 12.462 30.54 12.258C30.612 12.042 30.732 11.892 30.9 11.808C31.128 11.7 31.458 11.646 31.89 11.646H33.33V10.188C33.33 9.768 33.378 9.462 33.474 9.27C33.57 9.078 33.72 8.952 33.924 8.892C34.14 8.82 34.416 8.784 34.752 8.784C35.088 8.784 35.358 8.82 35.562 8.892C35.778 8.952 35.928 9.06 36.012 9.216C36.12 9.444 36.174 9.774 36.174 10.206V11.646Z",
    fill: "#1D3354"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_802_771",
    x: 22,
    y: 4,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_802_771"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_802_771",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadimageicon);
export default __webpack_public_path__ + "static/media/uploadimageicon.d95a4d6b0fcb6dcea03dc786950f55f8.svg";
export { ForwardRef as ReactComponent };